import { GeoJson } from '@ais-ui/api-spec/shapes';
import { useRoutes } from '../../Routes/RoutesContext';
import { useMapPanelContext } from '../../Map/MapPanel/MapPanelContext';
import { CENTERCOMPONENTS } from '../../Map/MapPanel/CenterComponents';
import { DropdownMenuItem } from '@ais-ui/ui-core';
import React from 'react';

interface ShowRoutesTableDropdownButtonProps {
  shape: GeoJson;
}

export const ShowRoutesTableDropdownButton = ({
  shape,
}: ShowRoutesTableDropdownButtonProps) => {
  const { setShape } = useRoutes();
  const { setCenterComponent } = useMapPanelContext();

  const onShowRoutesTable = () => {
    setCenterComponent(CENTERCOMPONENTS.ROUTES);
    setShape(shape);
  };

  return (
    <DropdownMenuItem onClick={onShowRoutesTable}>
      Routes table
    </DropdownMenuItem>
  );
};
